module.exports = __webpack_public_path__ + "static/media/Colony-Farms-By-Laws.a07b5118.pdf";